// [PAIEMENTS] Grille des opérateurs (Orange Money, Wave, MTN, Moov, carte…) + référence transaction
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Check } from "lucide-react";

export function PaymentOperatorPicker({
  operators, value, onChange, otherLabel, onOtherLabelChange, reference, onReferenceChange, primaryColor = "#FF4500", compact = false,
}) {
  return (
    <div className={compact ? "space-y-2" : "mt-2 space-y-1.5"} data-testid="payment-operator-picker">
      <Label className="text-muted-foreground" style={{ fontSize: '10px' }}>Opérateur de paiement *</Label>
      <div style={{ display: 'grid', gridTemplateColumns: compact ? 'repeat(3, 1fr)' : 'repeat(3, 1fr)', gap: '6px' }}>
        {operators.map((op) => {
          const active = value === op.id;
          const Icon = op.icon;
          return (
            <button
              key={op.id}
              type="button"
              onClick={() => onChange(op.id)}
              data-testid={`operator-btn-${op.id}`}
              className="payment-btn"
              style={{
                background: active ? primaryColor : op.color,
                borderColor: active ? primaryColor : op.color,
                color: active ? '#FFFFFF' : op.text,
                boxShadow: active ? `0 4px 14px -4px ${primaryColor}80` : 'none',
                transform: active ? 'translateY(-1px)' : 'none',
                position: 'relative',
              }}
              title={op.label}
            >
              {active && <Check style={{ position: 'absolute', top: 3, right: 3, width: 10, height: 10 }} />}
              <Icon style={{ width: '14px', height: '14px' }} />
              <span style={{ fontSize: '10px', fontWeight: 700, lineHeight: 1.1, textAlign: 'center' }}>{op.short}</span>
            </button>
          );
        })}
      </div>
      {value === "other" && (
        <Input
          value={otherLabel}
          onChange={(e) => onOtherLabelChange(e.target.value)}
          placeholder="Précisez (ex : Push, virement, chèque…)"
          className="h-9"
          style={{ fontSize: '13px' }}
          data-testid="operator-other-input"
        />
      )}
      {value && (
        <Input
          value={reference}
          onChange={(e) => onReferenceChange(e.target.value)}
          placeholder="Référence transaction (optionnel)"
          className="h-9"
          style={{ fontSize: '13px' }}
          data-testid="payment-reference-input"
        />
      )}
    </div>
  );
}
